import { EmbeddedMod } from "@src/store/slices/experienceBuilder/types";
import { getModHandler } from "@src/store/slices/experienceBuilder/common/utils/modHandlerRegistry";

export const normalizeMod = (mod: EmbeddedMod) =>
  getModHandler(mod).normalize(mod);
